<div class="teranet-progress-bar"
     [ngStyle]="{ 'width.%': value, 'background-color': foreground }">
</div>